import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { RoundedMinusIcon } from "../../../ui/icons/RoundedMinusIcon"
import { RoundedPlusIcon } from "../../../ui/icons/RoundedPlusIcon"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { TableSelect } from "../../../ui/molecules/tableSelect"
import { Alert } from "../../../ui/organisms/alert"
import { formatDecimalTime, optionsFormatter, OptionType, ServiceTypeUnitOptions } from "../../../utils"
import { HoursMinutesBox } from "../components/hoursMinutes"
import { ServiceTypeCategoryEnum } from "../dataService/dto"
import {
    AdditionalExpenseCreation, AdditionalExpenseDelete, AdditionalExpenseValidation,
    GetAllAdditionalExpense, GetAllCustomerBillingWorksheet, GetAllService, GetAllServiceType,
    resetAECreationStatus, resetAEDeleteStatus, resetAEValidationStatus, resetGetAllSTStatus,
    resetServiceCreationStatus, resetServiceDeleteStatus, resetServiceValidationStatus,
    ServiceCreation, ServiceDelete, ServiceValidation,
    setAECreationOfficerId, setAECreationServiceTypeId, setAECreationTaxableFee,
    setServiceCreationDate, setServiceCreationOfficerId, setServiceCreationServiceTypeId, setServiceCreationUnitEmployed,
} from "../slice"

interface Props {
    close: () => void
}

export function SchedaCalcoloListEditPopup(props: Props) {
    const dispatch = useAppDispatch()
    const serviceAndBillingState = useAppSelector(state => state.billingAndServiceType)
    const sessionState = useAppSelector(state => state.session)
    const userState = useAppSelector(state => state.users)

    const [serviceAddFlag, setServiceAddFlag] = useState(false)
    const [additionalAddFlag, setAdditionalAddFlag] = useState(false)
    const [serviceST, setServiceST] = useState<OptionType[]>([])
    const [additionalST, setAdditionalST] = useState<OptionType[]>([])
    const [serviceToDel, setServiceToDel] = useState<string | null>(null)
    const [additionalToDel, setAdditionalToDel] = useState<string | null>(null)
    const [showServiceAlert, setShowServiceAlert] = useState(false)
    const [showAdditionalAlert, setShowAdditionalAlert] = useState(false)

    const hoursMinutesPredicate = (): boolean =>
        serviceAndBillingState.serviceCreationRequest.serviceTypeId !== undefined &&
        serviceST
            .filter(st => st.value === serviceAndBillingState.serviceCreationRequest.serviceTypeId)
            .map(st => st.label.split(' - ')[1])[0] === 'Ore/Minuti'

    useEffect(() => {
        dispatch(setServiceCreationDate(new Date()))
        dispatch(setServiceCreationOfficerId(userState.findMeResponse.id))
        dispatch(setAECreationOfficerId(userState.findMeResponse.id))
        dispatch(GetAllService({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllServiceFilters.customerBillingWorksheetId }))
        dispatch(GetAllAdditionalExpense({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllAdditionalExpenseFilters.customerBillingWorksheetId }))
        dispatch(GetAllServiceType({ itemsPerPage: 0, page: 0, billingWorksheetId: serviceAndBillingState.getAllServiceTypeFilters.billingWorksheetId }))
    }, [])

    useEffect(() => {
        if (serviceAndBillingState.getAllServiceTypeStatus !== 'successfully' ||
            !serviceAndBillingState.getAllServiceTypeResponse) return
        dispatch(resetGetAllSTStatus())
        setServiceST(
            serviceAndBillingState.getAllServiceTypeResponse.data
                .filter(st => st.category === ServiceTypeCategoryEnum.SERVIZIO)
                .map(st => ({ value: st.id, label: `[${st.code}] - ${optionsFormatter(st.unitType, ServiceTypeUnitOptions)}` } as OptionType))
        )
        setAdditionalST(
            serviceAndBillingState.getAllServiceTypeResponse.data
                .filter(st => st.category === ServiceTypeCategoryEnum.SPESA_AGGIUNTIVA)
                .map(st => ({ value: st.id, label: `[${st.code}]` } as OptionType))
        )
    }, [serviceAndBillingState.getAllServiceTypeStatus])

    useEffect(() => {
        if (serviceAndBillingState.serviceValidationStatus !== 'successfully') return
        dispatch(resetServiceValidationStatus())
        dispatch(ServiceCreation(serviceAndBillingState.serviceCreationRequest))
    }, [serviceAndBillingState.serviceValidationStatus])

    useEffect(() => {
        if (serviceAndBillingState.serviceCreationStatus !== 'successfully') return
        dispatch(resetServiceCreationStatus())
        setServiceAddFlag(false)
        dispatch(setServiceCreationServiceTypeId(undefined))
        dispatch(setServiceCreationUnitEmployed(undefined))
        dispatch(GetAllService({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllServiceFilters.customerBillingWorksheetId }))
        dispatch(GetAllCustomerBillingWorksheet({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [serviceAndBillingState.serviceCreationStatus])

    useEffect(() => {
        if (serviceAndBillingState.serviceDeleteStatus !== 'successfully') return
        dispatch(resetServiceDeleteStatus())
        setServiceToDel(null)
        dispatch(GetAllService({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllServiceFilters.customerBillingWorksheetId }))
        dispatch(GetAllCustomerBillingWorksheet({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [serviceAndBillingState.serviceDeleteStatus])

    useEffect(() => {
        if (serviceAndBillingState.additionalExpenseValidationStatus !== 'successfully') return
        dispatch(resetAEValidationStatus())
        dispatch(AdditionalExpenseCreation(serviceAndBillingState.additionalExpenseCreationRequest))
    }, [serviceAndBillingState.additionalExpenseValidationStatus])

    useEffect(() => {
        if (serviceAndBillingState.additionalExpenseCreationStatus !== 'successfully') return
        dispatch(resetAECreationStatus())
        setAdditionalAddFlag(false)
        dispatch(setAECreationServiceTypeId(undefined))
        dispatch(setAECreationTaxableFee(undefined))
        dispatch(GetAllAdditionalExpense({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllAdditionalExpenseFilters.customerBillingWorksheetId }))
        dispatch(GetAllCustomerBillingWorksheet({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [serviceAndBillingState.additionalExpenseCreationStatus])

    useEffect(() => {
        if (serviceAndBillingState.additionalExpenseDeleteStatus !== 'successfully') return
        dispatch(resetAEDeleteStatus())
        setAdditionalToDel(null)
        dispatch(GetAllAdditionalExpense({ itemsPerPage: 0, page: 0, customerBillingWorksheetId: serviceAndBillingState.getAllAdditionalExpenseFilters.customerBillingWorksheetId }))
        dispatch(GetAllCustomerBillingWorksheet({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [serviceAndBillingState.additionalExpenseDeleteStatus])

    const SectionHeader = ({ label, color }: { label: string; color: 'green' | 'orange' }) => (
        <div className="flex items-center gap-2">
            <span className={`w-1 h-5 rounded-full inline-block ${color === 'green' ? 'bg-brandPrimary-500' : 'bg-orange-400'}`} />
            <span className={`text-sm font-semibold uppercase tracking-wide ${color === 'green' ? 'text-brandPrimary-600' : 'text-orange-600'}`}>
                {label}
            </span>
        </div>
    )

    const ActionRow = ({ onAdd, onRemove, disableRemove, addLabel, removeLabel, color }: {
        onAdd: () => void; onRemove: () => void; disableRemove: boolean
        addLabel: string; removeLabel: string; color: 'gray' | 'orange'
    }) => (
        <div className="flex justify-end gap-3">
            <ButtonComponent variant="outline" color={color} size="md" iconPosition="left" icon={<RoundedPlusIcon />} label={addLabel} onClick={onAdd} />
            <ButtonComponent disabled={disableRemove} variant="outline" color="red" size="md" iconPosition="left" icon={<RoundedMinusIcon color="rgba(255,68,61,1)" />} label={removeLabel} onClick={onRemove} />
        </div>
    )

    const DeleteAlert = ({ message, onConfirm, onCancel }: { message: string; onConfirm: () => void; onCancel: () => void }) => (
        <div className="flex flex-col items-center gap-4">
            <p className="text-sm text-neutral-700">{message}</p>
            <div className="flex items-center gap-4">
                <ButtonComponent variant="outline" color="gray" iconPosition="off" label="Annulla" size="md" onClick={onCancel} />
                <ButtonComponent variant="solid" color="orange" iconPosition="off" label="Elimina" size="md" onClick={onConfirm} />
            </div>
        </div>
    )

    return (
        <div className="px-6 py-5 flex flex-col gap-5">
            <div className="flex flex-col gap-3">
                <SectionHeader label="Elenco Servizi" color="green" />
                <TableSelect
                    type="radio"
                    onChange={value => setServiceToDel(value[0])}
                    headers={['Codice', 'Descrizione', 'Tipo Unità', 'Quantità', 'Imponibile', 'Iva', 'Importo']}
                    data={serviceAndBillingState.getAllServiceResponse?.data.map(s => ({
                        value: s.id,
                        labels: [
                            `[${s.serviceTypeCode}]`,
                            s.serviceTypeDescription,
                            optionsFormatter(s.unitType, ServiceTypeUnitOptions) || '',
                            String(s.unitType === 'ORE' ? formatDecimalTime(s.unitEmployed) : s.unitEmployed),
                            "€" + String(s.taxableFee),
                            "€" + String(s.iva),
                            "€" + String(s.totalFee),
                        ]
                    })) || []}
                />

                {!serviceAddFlag && (
                    <ActionRow
                        color="gray" addLabel="Nuovo Servizio" removeLabel="Rimuovi Servizio"
                        disableRemove={serviceToDel === null}
                        onAdd={() => setServiceAddFlag(true)}
                        onRemove={() => setShowServiceAlert(true)}
                    />
                )}

                {serviceAddFlag && (
                    <div className="flex items-end gap-3 rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-4 shadow-sm">
                        <div className="flex-1">
                            <MadfarmStaticSelect
                                customZIndex={9999}
                                label="Tipo di Servizio" noOptionsMessage="" placeholder="Specifica tipo di servizio..."
                                errorLabel="Tipo di servizio mancante"
                                error={serviceAndBillingState.serviceErrors.serviceTypeId}
                                options={serviceST}
                                value={serviceAndBillingState.serviceCreationRequest.serviceTypeId}
                                onChange={value => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setServiceCreationServiceTypeId(newValue))
                                }}
                            />
                        </div>
                        <div className="flex-1">
                            {hoursMinutesPredicate() ? (
                                <HoursMinutesBox onChange={value => dispatch(setServiceCreationUnitEmployed(value))} />
                            ) : (
                                <MadfarmInput
                                    label="Unità impiegate" placeholder="Specifica unità impiegate..."
                                    supportingText={serviceAndBillingState.serviceErrors.unitEmployed ? 'Unità mancanti' : undefined}
                                    error={serviceAndBillingState.serviceErrors.unitEmployed}
                                    value={serviceAndBillingState.serviceCreationRequest.unitEmployed?.toString()}
                                    onChangeText={text => dispatch(setServiceCreationUnitEmployed(text))}
                                />
                            )}
                        </div>
                        <div className="flex gap-2 shrink-0">
                            <ButtonComponent variant="outline" color="gray" size="lg" iconPosition="off" label="Annulla"
                                onClick={() => {
                                    dispatch(setServiceCreationServiceTypeId(undefined))
                                    dispatch(setServiceCreationUnitEmployed(undefined))
                                    setServiceAddFlag(false)
                                }}
                            />
                            <ButtonComponent variant="solid" color="blue" size="lg" iconPosition="left" icon={<RoundedPlusIcon />} label="Salva"
                                onClick={() => dispatch(ServiceValidation(serviceAndBillingState.serviceCreationRequest))}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="border-t border-neutral-200" />

            <div className="flex flex-col gap-3">
                <SectionHeader label="Elenco Spese Aggiuntive" color="orange" />
                <TableSelect
                    type="radio" color="orange"
                    onChange={value => setAdditionalToDel(value[0])}
                    headers={['Codice', 'Descrizione', 'Imponibile', 'Iva', 'Importo']}
                    data={serviceAndBillingState.getAllAdditionalExpenseResponse?.data.map(s => ({
                        value: s.id,
                        labels: [
                            `[${s.serviceTypeCode}]`,
                            s.serviceTypeDescription,
                            "€" + String(s.taxableFee),
                            "€" + String(s.iva),
                            "€" + String(s.totalFee),
                        ]
                    })) || []}
                />

                {!additionalAddFlag && (
                    <ActionRow
                        color="orange" addLabel="Nuova Spesa Addizionale" removeLabel="Rimuovi Spesa"
                        disableRemove={additionalToDel === null}
                        onAdd={() => setAdditionalAddFlag(true)}
                        onRemove={() => setShowAdditionalAlert(true)}
                    />
                )}

                {additionalAddFlag && (
                    <div className="flex items-end gap-3 rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-4 shadow-sm">
                        <div className="flex-1">
                            <MadfarmStaticSelect
                                customZIndex={9999}
                                label="Tipo di Servizio" noOptionsMessage="" placeholder="Specifica tipo di servizio..."
                                errorLabel="Tipo di servizio mancante"
                                error={serviceAndBillingState.additionalErrors.serviceTypeId}
                                options={additionalST}
                                value={serviceAndBillingState.additionalExpenseCreationRequest.serviceTypeId}
                                onChange={value => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setAECreationServiceTypeId(newValue))
                                }}
                            />
                        </div>
                        <div className="flex-1">
                            <MadfarmInput
                                label="Totale" placeholder="Specifica totale..."
                                supportingText={serviceAndBillingState.additionalErrors.taxableFee ? 'Totale mancante' : undefined}
                                error={serviceAndBillingState.additionalErrors.taxableFee}
                                value={serviceAndBillingState.additionalExpenseCreationRequest.taxableFee?.toString()}
                                onChangeText={text => dispatch(setAECreationTaxableFee(text))}
                            />
                        </div>
                        <div className="flex gap-2 shrink-0">
                            <ButtonComponent
                                variant="outline"
                                color="orange"
                                size="md"
                                iconPosition="off"
                                label="Annulla"
                                onClick={() => {
                                    dispatch(setAECreationServiceTypeId(undefined))
                                    dispatch(setAECreationTaxableFee(undefined))
                                    setAdditionalAddFlag(false)
                                }}
                            />
                            <ButtonComponent
                                variant="solid"
                                color="orange"
                                size="md"
                                iconPosition="left"
                                icon={<RoundedPlusIcon />}
                                label="Salva"
                                onClick={() => dispatch(AdditionalExpenseValidation(serviceAndBillingState.additionalExpenseCreationRequest))}
                            />
                        </div>
                    </div>
                )}
            </div>
            {showServiceAlert && serviceToDel && (
                <Alert title="Conferma operazione" close={() => setShowServiceAlert(false)}>
                    <DeleteAlert
                        message="Sei sicuro di voler eliminare il servizio?"
                        onCancel={() => setShowServiceAlert(false)}
                        onConfirm={() => { dispatch(ServiceDelete(serviceToDel)); setShowServiceAlert(false) }}
                    />
                </Alert>
            )}

            {showAdditionalAlert && additionalToDel && (
                <Alert title="Conferma operazione" close={() => setShowAdditionalAlert(false)}>
                    <DeleteAlert
                        message="Sei sicuro di voler eliminare la spesa aggiuntiva?"
                        onCancel={() => setShowAdditionalAlert(false)}
                        onConfirm={() => { dispatch(AdditionalExpenseDelete(additionalToDel)); setShowAdditionalAlert(false) }}
                    />
                </Alert>
            )}
        </div>
    )
}